import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';
import { translations } from '../../i18n/translations';

/**
 * GIA — Qualität & Sicherheit.
 * Kein Vollflächen-Hintergrund mehr: das GIA-HQ-Foto steht als Bild
 * neben dem Logo, der Text läuft über die gesamte Folienbreite.
 */
export default function SectionSicherheit() {
  const { lang } = useT();
  const T = translations[lang]?.sicherheit || translations.de.sicherheit;

  return (
    <SectionShell id="sicherheit" className="relative overflow-hidden">
      <div className="w-full">
        <Reveal>
          <div className="text-center">
            <div className="overline mb-4">{T.overline}</div>
            <h2
              className="font-display tracking-tight leading-[1.02] text-white uppercase mb-20 md:mb-24"
              style={{ fontSize: 'clamp(3.6rem, 6.4vw, 8rem)', letterSpacing: '-0.01em' }}
              data-testid="sicherheit-title"
            >
              {T.title}
            </h2>
          </div>
        </Reveal>

        {/* Text links, Logo rechts daneben */}
        <Reveal delay={150}>
          <div className="grid grid-cols-12 gap-6 md:gap-10 items-center mb-8">
            <div className="col-span-12 md:col-span-7">
              <p
                className="font-display text-white/95 tracking-tight mb-8 leading-snug"
                style={{ fontSize: 'clamp(2.8rem, 3.9vw, 5rem)' }}
              >
                {T.headline}
              </p>
              <p className="font-ui text-white/85 leading-relaxed mb-6" style={{ fontSize: 'clamp(1.95rem, 2.55vw, 3.2rem)' }}>
                {T.p1}
              </p>
              <p className="font-ui text-white/85 leading-relaxed mb-6" style={{ fontSize: 'clamp(1.95rem, 2.55vw, 3.2rem)' }}>
                {T.p2}
              </p>
              <p className="font-ui text-white/85 leading-relaxed" style={{ fontSize: 'clamp(1.95rem, 2.55vw, 3.2rem)' }}>
                {T.p3}
              </p>
            </div>
            <div
              className="col-span-12 md:col-span-5 relative flex items-center justify-center self-center"
              data-testid="light-band-wrap"
            >
              {/* Ambient gold glow — sits behind the box */}
              <div
                aria-hidden="true"
                className="gia-box-glow"
                style={{
                  position: 'absolute',
                  inset: '-70px',
                  background:
                    'radial-gradient(ellipse at 50% 55%, rgba(242,217,121,0.75) 0%, rgba(242,217,121,0.42) 22%, rgba(242,217,121,0.12) 48%, rgba(242,217,121,0) 68%)',
                  filter: 'blur(56px)',
                  zIndex: 0,
                  pointerEvents: 'none',
                }}
              />
              <div
                className="relative rounded-2xl flex items-center justify-center w-full"
                style={{
                  background: 'linear-gradient(180deg, #ffffff 0%, #fbf6e6 100%)',
                  border: '1px solid rgba(242,217,121,0.75)',
                  boxShadow:
                    '0 0 0 1px rgba(255,255,255,0.6) inset, 0 22px 60px rgba(0,0,0,0.55), 0 0 30px rgba(242,217,121,0.55), 0 0 90px rgba(242,217,121,0.35)',
                  zIndex: 1,
                  aspectRatio: '4 / 3',
                  padding: 'clamp(24px, 3vw, 48px)',
                }}
                data-testid="light-band"
              >
                <img
                  src="/source-pptx/image40.png"
                  alt="GIA — Gemological Institute of America"
                  loading="lazy"
                  className="block object-contain select-none"
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectPosition: 'center center',
                  }}
                  draggable={false}
                  data-testid="gia-logo"
                />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
